import React, { useEffect } from "react";
import DataBantuan from "../../componen/bantuan/DataBantuan" 
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMeAdmin } from "../../fitur/AuthSlice";
import Footer from "../../componen/Footer";
import { Layout } from "../../layout/Layout";

export const DataBantuanPages = () => {
       const dispatch = useDispatch();
              const navigate = useNavigate();
              const { isError } = useSelector((state) => state.authAdmin);
            
              useEffect(() => {
                dispatch(getMeAdmin());
              }, [dispatch]);
            
              useEffect(() => {
                if (isError) {
                  navigate("/");
                }
              }, [isError, navigate]);
            return(
                <Layout>
                    <DataBantuan /> 
                    </Layout>
            )
            }
